<template lang="pug" src="./reports-list.pug"> </template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        requestProcessing: false
    }),
    computed: {
        ...mapState({
            items: state => state.reports.items,
            pagination: state => state.reports.pagination,
        }),
        headers() {
            return ['number', 'name', 'category', 'sqlQuery', 'createdAt', 'updatedAt', 'action'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Reports.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        query: {
            get() {
                return this.$store.state.reports.filters.query;
            },
            set(val) {
                return this.$store.commit('reports/SET_QUERY', val);
            }
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('reports/getItems', {
                page,
                q: this.query
            }).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        }
    }
};
</script>
